import styled from "@emotion/styled";
import React from "react";
import QuestionWrapper from "./QuestionWrapper";

const StyledQuestionLabel = styled.span`
  display: flex;
  margin-bottom: 6px;
`;

const QuestionLabel = (props: { children: React.ReactNode }) => {
  return (
    <QuestionWrapper>
      <StyledQuestionLabel>{props.children}</StyledQuestionLabel>
    </QuestionWrapper>
  );
};

export default QuestionLabel;
